import { Component, OnInit, Input } from '@angular/core';
import { GeneralWPService } from 'src/app/core/http/web/generalWp.service';
declare var $: any;
@Component({
  selector: 'app-on-navbar',
  templateUrl: './on-navbar.component.html',
  styleUrls: ['./on-navbar.component.scss']
})
export class OnNavbarComponent implements OnInit {
  @Input() public loadServ: boolean = true;
  @Input() public data: any;
  public mdlOpen: boolean;
  constructor(
    private gWPServ: GeneralWPService
  ) {}

  ngOnInit() {
    console.log('Data en navbar on: ', this.data);
    if (this.loadServ) {
      this.getGeneralOptions();
    }
  }

  getGeneralOptions() {
    this.gWPServ.getGeneralOptions().subscribe(
      data => {
        this.data = data.data;
      },
      err => {
        console.error(err);
      }
    );
  }
}
